import { createEvent, EventsUnion } from './types';

export const ElevioEvents = {
  /**
   * Triggered whenever an article has been viewed, either in a custom element or in the Assistant.
   *
   * NOTE: this is not used when a knowledge base page is viewed, instead see { pageViewArticle }
   * */
  articleView: (context: {
    event_ctx_articleId: string;
    event_ctx_title: string;
  }) => createEvent('article_view', context),

  /**
   * Triggered when the Assistant launcher button is clicked.
   */
  launcherClicked: () => createEvent('launcher_click'),

  /**
   * Triggered when the the home page is viewed in the knowledge base.
   */
  pageViewIndex: () => createEvent('page_view_index'),

  /**
   * Triggered when an article page is viewed in the knowledge base.
   */
  pageViewArticle: (context: {
    event_ctx_id: string;
    event_ctx_title: string;
  }) => createEvent('page_view_article', context),

  /**
   * Triggered when a category page is viewed in the knowledge base.
   */
  pageViewCategory: (context: {
    event_ctx_categoryId: string;
    event_ctx_title: string;
  }) => createEvent('page_view_category', context),

  /**
   * Triggered when a search has been completed.
   *
   * @param
   */
  searchQuery: (context: {
    event_ctx_queryTerm: string;
    event_ctx_totalResults: number;
    event_ctx_articleIds: Array<string>;
  }) => createEvent('search_query', context),

  /**
   * Triggered when a user clicks on a search result.
   */
  searchClick: (context: {
    event_ctx_query: string;
    event_ctx_id: string;
    event_ctx_index: number;
    event_ctx_title: string;
  }) => createEvent('search_click', context),

  walkthroughComplete: (context: { custom_attributes: string }) =>
    createEvent('walkthrough_complete', context),

  walkthroughSkip: (context: { custom_attributes: string }) =>
    createEvent('walkthrough_skip', context),

  walkthroughStepView: (context: {
    custom_attributes: string;
    event_ctx_order: number;
  }) => createEvent('walkthrough_step_view', context),

  widgetClose: () => createEvent('widget_close'),

  widgetOpen: () => createEvent('widget_open'),

  articleFeedbackReaction: (context: {
    event_ctx_id: string; // articleId
    event_ctx_reaction: 1 | 0; // 1 is positive, 0 is negative.
    event_ctx_title: string; // article title
  }) => createEvent('article_feedback_reaction', context),

  /**
   * Triggered when a user submits feedback text for an article.
   * NOTE: you will need a valid nonce first.
   */
  articleFeedbackText: (context: {
    event_ctx_email?: string; // Feedback email
    event_ctx_id: string; // Article Id
    event_ctx_text: string; // Feedback text
    event_ctx_title: string; // Article Title
    custom_attributes: { nonce: string };
  }) => createEvent('article_feedback_text', context),
};

export type IElevioEvents = EventsUnion<typeof ElevioEvents>;
